import { RefObject, useLayoutEffect, useState } from 'react'
import useResizeObserver from '@react-hook/resize-observer'

const useSize = (target: RefObject<HTMLElement>) => {
  // NB: omitting toJSON property to placate TS compiler (the type ResizeObserverEntry of the contentRect property doesn't play along)
  const [size, setSize] = useState<DOMRect | Omit<DOMRectReadOnly, 'toJSON'>>()

  useLayoutEffect(() => {
    const nextSize = target.current?.getBoundingClientRect()
    setSize(nextSize)
  }, [target])

  useResizeObserver(target, (entry) => setSize(entry.contentRect))
  return size
}

export default useSize
